(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2263],{

/***/ 70097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AntisocialPage; }
});

// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Governance/Antisocial/index.tsx










var AntisocialPage = function AntisocialPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Policy Against Antisocial Forces",
      subTitleText: "\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u3078\u306E\u5BFE\u5FDC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u6392\u9664\u306B\u5411\u3051\u305F\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9\u53CA\u3073\u305D\u306E\u6574\u5099\u72B6\u6CC1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u5F53\u793E\u306F\u3001\u793E\u4F1A\u7684\u79E9\u5E8F\u3084\u4F01\u696D\u306E\u5065\u5168\u306A\u6D3B\u52D5\u306B\u60AA\u5F71\u97FF\u3092\u4E0E\u3048\u308B\u3042\u3089\u3086\u308B\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u3068\u306F\u4E00\u5207\u95A2\u308F\u3089\u306A\u3044\u3068\u3044\u3046\u65B9\u91DD\u306E\u3082\u3068\u3001\u300CTRIAL\u306E\u884C\u52D5\u6307\u91DD\u300D\u53CA\u3073\u300C\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u5BFE\u7B56\u898F\u7A0B\u300D\u3092\u5F53\u4F01\u696D\u96C6\u56E3\u306E\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u3078\u5468\u77E5\u30FB\u5FB9\u5E95\u3057\u3001\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u3068\u306E\u95A2\u4FC2\u6392\u9664\u306B\u5411\u3051\u3001\u5F53\u4F01\u696D\u96C6\u56E3\u5168\u4F53\u3067\u306E\u4F01\u696D\u502B\u7406\u306E\u6D78\u900F\u306B\u53D6\u308A\u7D44\u3093\u3067\u304A\u308A\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u793E\u5185\u4F53\u5236\u3068\u3057\u3066\u306F\u3001\u6C11\u4E8B\u4ECB\u5165\u66B4\u529B\u306B\u95A2\u308F\u308B\u30C8\u30E9\u30D6\u30EB\u306B\u5BFE\u3057\u3066\u306F\u30B0\u30EB\u30FC\u30D7\u6CD5\u52D9\u90E8\u9577\u3092\u7DCF\u62EC\u8CAC\u4EFB\u8005\u3068\u3057\u3066\u5BFE\u5FDC\u3059\u308B\u4F53\u5236\u3092\u3068\u3063\u3066\u304A\u308A\u307E\u3059\u3002\u307E\u305F\u3001\u5404\u90E8\u9580\u306B\u53D6\u5F15\u5148\u3068\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u306E\u6392\u9664\u306B\u95A2\u3059\u308B\u6761\u9805\u3092\u76DB\u308A\u8FBC\u3093\u3060\u5951\u7D04\u66F8\u3092\u7DE0\u7D50\u3059\u308B\u3053\u3068\u3092\u6307\u793A\u3057\u5B9F\u884C\u3057\u3066\u304A\u308A\u307E\u3059\u3002\u307E\u305F\u3001\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u304B\u3089\u306E\u5727\u529B\u306B\u5BFE\u6297\u3059\u308B\u305F\u3081\u3001\u8B66\u5BDF\u7F72\u3084\u4F01\u696D\u9632\u885B\u5BFE\u7B56\u5354\u8B70\u4F1A\u7B49\u306E\u5916\u90E8\u306E\u5C02\u9580\u6A5F\u95A2\u3068\u306E\u9023\u643A\u95A2\u4FC2\u3082\u69CB\u7BC9\u3057\u3066\u304A\u308A\u307E\u3059\u3002"
      })]
    })]
  });
};

AntisocialPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir/'
  }, {
    name: 'コーポレート・ガバナンス',
    path: '/ir/governance/'
  }, {
    name: '反社会的勢力への対応',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u3078\u306E\u5BFE\u5FDC",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u6392\u9664\u306B\u5411\u3051\u305F\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9\u53CA\u3073\u305D\u306E\u6574\u5099\u72B6\u6CC1\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/governance/antisocial/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/ir/governance/antisocial.tsx


/***/ }),

/***/ 85918:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/governance/antisocial",
      function () {
        return __webpack_require__(70097);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,4535,9774,2888,179], function() { return __webpack_exec__(85918); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);